<template>
    <div>
        <Modal v-model="$parent.truckListDialog" :mask-closable="false" width="550">
            <div slot="header"><strong>Truck ({{truckArr.length}})</strong>
                <Icon type="md-add-circle" style="float: right" size="22" @click="onAddTruck()"></Icon>
            </div>
            <div>
                <Table :columns="truckHeaders" :data="truckArr" size="small" max-height="400" v-if="$parent.truckListDialog">
                    <template slot-scope="{ row }" slot="routes">
                        <Poptip trigger="hover">
                            <Icon type="md-information"></Icon>
                            <div slot="content" class="api">
                                <table>
                                    <thead><tr><th>FROM</th><th>TO</th></tr></thead>
                                    <tbody>
                                    <tr v-for="route in row.routes">
                                      <td>{{route.fromCity}}</td><td>{{route.toCity}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Poptip>&nbsp;
                    </template>
                    <template slot-scope="{ row }" slot="action">
                        <Icon type="md-create" @click="onEditTruck(row)"></Icon>&nbsp;
                        <Icon type="md-close" @click="onDeleteTruck(row.id)"></Icon>
                    </template>
                </Table>
            </div>
            <div slot="footer">
                <Button style="background: #999999; color: white;font-weight: bolder" @click="$parent.truckListDialog=false">CLOSE</Button>
            </div>
        </Modal>

        <add-truck ref="truck-form"></add-truck>
    </div>
</template>

<script>
    import {DELETE_TRUCK} from '../../graphql/mutations/vehicle'
    import { GET_TRUCKS} from '../../graphql/queries/vehicle'
    import { SUBSCRIBE_TRUCKS} from '../../graphql/subscription/vehicle'
    import AddTruck from './AddTruck'
    export default {
        apollo: {
            truck: {
                query: GET_TRUCKS,
                subscribeToMore: {
                    document: SUBSCRIBE_TRUCKS,
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.truckArr = subscriptionData.data.truck;
                    },
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.truckArr = data.truck;
                    }
                }
            }
        },
        name: "Truck",
        components: {AddTruck},
        data: function(){
            return{
                mutation_DELETE_TRUCK: DELETE_TRUCK,
                truckArr: [],
                truckHeaders: [
                    // {title: 'Name', key: 'name'},
                    {title: 'Transporter', key: 'company',
                        render:(h, params) => {return h('div',params.row.company.name)}},
                    {title: 'Plate', key: 'platNo', ellipsis: true},
                    {title: 'Capacity', key: 'capacity'},
                    // {title: 'KM limit', key: 'kmLimit'},
                    {title: 'Routes', slot: 'routes'},
                    {title: ' ', slot: 'action', width: 60}
                ]
            }
        },
        methods:{
            onAddTruck(transporterData){
                this.$refs['truck-form'].onAddTruck(transporterData);
            },
            onEditTruck(row){
                this.$refs['truck-form'].onEditTruck(row);
            },
            onDeleteTruck(truckId){
                this.$Modal.confirm({
                    title: 'Confirmation',
                    content: '<p>Are You sure want to delete Truck ?</p>',
                    loading: true,
                    onOk: () => {
                        this.deleteTruck(truckId, this.$Modal)
                    }
                });
            },
            deleteTruck(truckId, callback){
                this.$apollo.mutate({
                    mutation: this.mutation_DELETE_TRUCK,
                    variables: { truckId: truckId }
                }).then(function(response){
                    callback.remove();
                    this.$Message.success('Truck deleted successfully!');
                }).catch(function(err){
                    callback.remove();
                })
            }
        }
    }
</script>

<style scoped>
    /deep/ .ivu-modal-close{
        visibility: hidden;
    }
    /deep/ .code-uppercase > input{
        text-transform: uppercase;
    }
    /deep/ .ivu-table td {
        border-bottom: 0px;
        font-size: 14px;
    }
    /deep/ .ivu-table th {
        border-bottom: 0px;
        font-size: 14px;
        text-align: center;
    }
    /deep/ .ivu-table-wrapper {
        position: unset !important;
        border: 0px ;
    }
    /deep/ .ivu-table-cell {
        padding-left: 0px;
        padding-right: 0px;
        text-align: center;
    }
    /deep/ .ivu-modal-body{
        max-height: 500px !important;
        overflow-y: auto !important;
    }
   /deep/ table th,td{
       padding: 12px;
   }
</style>
